/* CWM · Motion-Boot
   Verbindet Lenis mit ScrollTrigger, startet die Sections erst danach
   und loest genau einen Refresh aus. Built by Audax CS */
(function () {
  var booted = false;

  window.cwmMotionQueue = window.cwmMotionQueue || [];
  window.cwmMotion = {
    ready: function (fn) {
      if (booted) { fn(); } else { window.cwmMotionQueue.push(fn); }
    }
  };

  function drain() {
    var q = window.cwmMotionQueue;
    window.cwmMotionQueue = [];
    q.forEach(function (fn) { try { fn(); } catch (e) { console.error('[cwm-motion]', e); } });
  }

  function refreshOnce() {
    var run = function () { ScrollTrigger.refresh(); };
    if (document.readyState === 'complete') setTimeout(run, 200);
    else window.addEventListener('load', function () { setTimeout(run, 200); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { setTimeout(run, 150); });
    }
  }

  function boot() {
    if (booted) return true;
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return false;
    if (!window.lenis) return false;

    booted = true;
    ScrollTrigger.config({ ignoreMobileResize: true });
    window.lenis.on('scroll', ScrollTrigger.update);
    drain();
    refreshOnce();
    return true;
  }

  if (boot()) return;

  var t = setInterval(function () { if (boot()) clearInterval(t); }, 40);

  /* Falls Lenis nach 6 s nicht da ist: ohne Lenis starten, statt gar nicht */
  setTimeout(function () {
    clearInterval(t);
    if (booted) return;
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;
    booted = true;
    ScrollTrigger.config({ ignoreMobileResize: true });
    drain();
    refreshOnce();
  }, 6000);
})();